import { EventEmitter } from '@angular/core';
import { SubscriptionBasedComponent } from '../subscription-helpers/subscription-based.component';
import { FilterStoreService } from '../services/filter-store.service';
import { FILTER_OPERATION, FilterObject } from './filter-object';
import { PageIndexService } from '../services/page-index-service';
import { CollectionHelper } from './collection-helper';
import { GeneralHelper } from './general-helper';

export abstract class FilterEnabledComponent extends SubscriptionBasedComponent {
  filtersChanged: EventEmitter<any> = new EventEmitter<any>();
  displayedFilters: FilterObject[] = [];
  protected initPageIndex: number;
  protected initPageSize: number;

  protected constructor(
    displayedFilters: any[],
    protected filterStoreService: FilterStoreService,
    protected pageIndexService: PageIndexService
  ) {
    super();
    let storedFilters = this.filterStoreService.getFilters(
      this.getLocalStorageKey()
    );
    CollectionHelper.filterInPlace(
      storedFilters,
      this.isInDisplayFilters,
      displayedFilters
    );
    if (storedFilters != null && storedFilters.length) {
      this.displayedFilters = storedFilters;
    } else {
      this.displayedFilters = displayedFilters;
    }
    for (let displayFilter of displayedFilters) {
      if (
        displayFilter.key != null &&
        displayFilter.key !== '' &&
        storedFilters != null &&
        storedFilters.length > 0 &&
        storedFilters.findIndex((sf) => sf.key === displayFilter.key) < 0
      ) {
        storedFilters.push(displayFilter);
      }
    }
    this.initPageIndex = pageIndexService.getPageIndex(
      this.getLocalStorageKey()
    );
    if (this.initPageIndex == null) {
      this.initPageIndex = 0;
    }
    this.initPageSize = pageIndexService.getPageSize(this.getLocalStorageKey());
    if (this.initPageSize == null) {
      this.initPageSize = 30;
    }
  }

  protected toggleFilter(filterName: string): void {
    let filterObject = this.displayedFilters.filter(
      (filter) => filter.key == filterName
    )[0];
    if (filterObject) {
      filterObject.active = !filterObject.active;
      if (!filterObject.active || filterObject.alwaysTriggerRequest) {
        this.filtersChanged.emit();
      }
    }
    this.filterStoreService.setFilters(
      this.getLocalStorageKey(),
      this.displayedFilters
    );
  }

  protected onFilterValueChange(filterData: any) {
    let filterName = filterData.key;
    let filterValue = filterData.value;
    let filterObject = this.displayedFilters.filter(
      (filter) => filter.key == filterName
    )[0];
    if (filterObject) {
      filterObject.value = filterValue.replace(' ', '_');
      this.filtersChanged.emit();
    }
    this.filterStoreService.setFilters(
      this.getLocalStorageKey(),
      this.displayedFilters
    );
  }
  protected generateFilterString(): string {
    let activeFilters = this.displayedFilters.filter(
      (e) => e.active && e.value && e.value.trim() != ''
    );

    let filters = [];
    activeFilters.forEach((filter) => {
      const value =
        filter.numeric &&
        filter.value != null &&
        !GeneralHelper.isNumeric(filter.value)
          ? 0
          : filter.value;
      let prefix = filter.strictEquality || filter.startsWith ? '' : '*';
      let suffix = filter.strictEquality ? '' : '*';
      let opToken = this.getOpToken(filter.strictEquality, filter.operation);
      filters.push(filter.key + opToken + prefix + value + suffix);
    });

    return filters.join(',');
  }

  protected getOpToken(
    strictEquality?: boolean,
    operation?: FILTER_OPERATION
  ): string {
    switch (operation) {
      case FILTER_OPERATION.NEGATION:
        return '!';
      case FILTER_OPERATION.GREATER_THAN:
        return encodeURIComponent('>');
      case FILTER_OPERATION.LESS_THAN:
        return encodeURIComponent('<');
      case FILTER_OPERATION.LIKE:
        return encodeURIComponent('~');
      case FILTER_OPERATION.EQUALITY:
      default:
        return strictEquality ? encodeURIComponent('=') : ':';
    }
  }

  protected getFilterForKey(key: string): FilterObject {
    return this.displayedFilters.find((filter) => filter.key === key);
  }

  protected abstract getLocalStorageKey(): string;

  protected isInDisplayFilters(filter: any, displayFilters: any[]) {
    if (
      filter == null ||
      !CollectionHelper.isPopulated(displayFilters) ||
      !CollectionHelper.isPopulated(displayFilters[0])
    ) {
      return false;
    }
    return displayFilters[0].some((f) => {
      return f.key === filter.key;
    });
  }
}
